import { AuthState } from './reducer';

export const selectIdentity = (state: AuthState) => state.identity;
export const selectRefreshToken = (state: AuthState) => state.refreshToken;
export const selectRefreshLock = (state: AuthState) => state.refreshLock;
export const selectRefreshLockTimestamp = (state: AuthState) => state.refreshLockTimestamp;
export const selectError = (state: AuthState) => state.error;
export const selectPermissionLevel = (state: AuthState) => state.permissionLevel;
